<div class="app-dialog-body modal-body">
    <ng-content></ng-content>
</div>
